import { AuthConfig } from '@auth0/auth0-angular';
import { CacheLocation } from '@auth0/auth0-spa-js';

export const environment = {
  acmAPI: 'https://staging.api.agilitycoursemaster.com/v1/',
  auth0Config: {
    authorizationParams: {
      // request at login otherwise get an error when accessing the API
      audience: 'https://api.agilitycoursemaster.com',
      redirect_uri: 'https://staging.app.agilitycoursemaster.com/',
      scope: 'userIdentifier',
    },
    cacheLocation: 'localstorage' as CacheLocation,
    clientId: 'YwJExcNnLvIuGm2oRjHAC17gGBdp01ae',
    domain: 'agilitycoursemaster.auth0.com',
    httpInterceptor: {
      // Pass along Auth Header to URLs in allowedList
      allowedList: [
        {
          tokenOptions: {
            authorizationParams: {
              audience: 'https://api.agilitycoursemaster.com',
              scope: 'userIdentifier',
            },
          },
          uri: 'https://staging.api.agilitycoursemaster.com/*',
        },
      ],
    },
    useRefreshTokens: true,
  } as AuthConfig,
  env: 'staging',
  logoutURL: 'https://staging.app.agilitycoursemaster.com/',
  paddle: {
    sandbox: true,
    planId: 42067,
    vendorId: 2678,
  },
  production: true,
  rollbarAccessToken: '53c59871071f440d924c521b85cb0933',
  version: '4.0.0',
};
